module.exports = __webpack_public_path__ + "img/471-e30cac.png";